import { IHttpService, IPromise, IRequestShortcutConfig } from "angular";
import { EnvironmentService } from "@gtmhub/env";
import { ICheckinV2 } from "@webapp/okrs/metrics/models/metric.models";
import { IPersonalBestStats, IProcessStats, IProfileQueryParams, IProgressStats, ITeamTasksStats, IUserTasksStats } from "../models/models";

export type ProfileType = "user" | "team";

export class ProfileService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public getProcessStats(profileType: ProfileType, targetId: string, queryParams: IProfileQueryParams): IPromise<IProcessStats> {
    const url = this.env.getApiEndpoint(`profiles/${profileType}/process-stats/${targetId}?sessionIds=${queryParams.sessionIds}`);

    return this.$http.get<IProcessStats>(url).then((response) => response.data);
  }

  public getTaskStats(profileType: ProfileType, targetId: string): IPromise<ITeamTasksStats | IUserTasksStats> {
    const url = this.env.getApiEndpoint(`profiles/${profileType}/task-stats/${targetId}`);

    return this.$http.get<ITeamTasksStats | IUserTasksStats>(url).then((response) => response.data);
  }

  public getProgressStats(profileType: ProfileType, targetId: string, queryParams: IProfileQueryParams): IPromise<IProgressStats> {
    const url = this.env.getApiEndpoint(`profiles/${profileType}/progress-stats/${targetId}?sessionIds=${queryParams.sessionIds}`);

    return this.$http.get<IProgressStats>(url).then((response) => response.data);
  }

  public getPersonalBestStats(profileType: ProfileType, targetId: string): IPromise<IPersonalBestStats> {
    const url = this.env.getApiEndpoint(`/profiles/${profileType}/personal-best/${targetId}`);

    return this.$http.get<IPersonalBestStats>(url).then((response) => response.data);
  }

  public getLatestMetricUpdates(profileType: ProfileType, targetId: string, params: { limit: number }): IPromise<ICheckinV2[]> {
    const url = this.env.getApiEndpoint(`/profiles/${profileType}/metric-updates/${targetId}`);

    const query: IRequestShortcutConfig = {
      params,
    };

    return this.$http.get<ICheckinV2[]>(url, query).then((response) => response.data);
  }
}
